import { useEffect } from 'react'

type UseScrollContentsProps = {
  activeChapterElementRef: React.RefObject<HTMLAnchorElement>
  sliderRef: React.RefObject<HTMLDivElement>
  visibleChapterId: string | null
  firstChapterTitle?: string
}
export const useScrollContents = ({
  activeChapterElementRef,
  sliderRef,
  visibleChapterId,
  firstChapterTitle,
}: UseScrollContentsProps) => {
  useEffect(() => {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)')
      .matches
      ? 'instant'
      : 'smooth'

    const activeElement = activeChapterElementRef.current
    const container = sliderRef.current
    if (!activeElement || !container) return

    const isFirstChapter = firstChapterTitle === visibleChapterId
    if (isFirstChapter) {
      container.scroll({ top: 0, behavior })
      return
    }

    const containerRect = container.getBoundingClientRect()
    const activeElementRect = activeElement.getBoundingClientRect()
    const activeElementTop =
      activeElementRect.top - containerRect.top + container.scrollTop
    const activeElementBottom = activeElementTop + activeElementRect.height

    if (activeElementTop < container.scrollTop) {
      container.scroll({ top: activeElementTop, behavior })
      return
    }
    if (activeElementBottom > container.scrollTop + container.clientHeight) {
      container.scroll({
        top: activeElementBottom - container.clientHeight,
        behavior,
      })
    }
  }, [visibleChapterId, firstChapterTitle])
}
